// extracted by mini-css-extract-plugin
export default {"backDrop":"styles_backDrop__7b+24"};